// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdk-overlay-container {
  z-index: 1003 !important;
}

.mat-mdc-menu-panel.tour-step {
  margin-top: 4px;
  overflow: visible !important;
  padding: 0 !important;
  min-width: 250px !important;
  max-width: min(1360px, 95vw) !important;
  width: auto !important;
  box-shadow: none !important;
}

.mat-mdc-menu-panel.tour-step .mat-mdc-menu-content {
  overflow: visible !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.mat-mdc-menu-content.tour-step-card {
  padding: 15px !important;
}

.tour-step-card {
  position: relative;
  overflow: visible;
  width: auto;
  min-width: 250px;
  max-width: min(1360px, 95vw);
  border-radius: 12px;
  box-shadow: none;
  background: #fff;
}

.tour-step-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.08));
  z-index: 1;
}

.tour-step-arrow-bottom {
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: #fff;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-arrow-top {
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  border-bottom-color: #fff;
  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-arrow-top-left {
  top: -30px;
  left: 15px;
  border-bottom-color: #fff;
  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-arrow-top-right {
  top: -30px;
  left: auto;
  right: 15px;
  border-bottom-color: #fff;
  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-arrow-left {
  left: -21px;
  top: 50%;
  transform: translateY(-50%);
  border: 12px solid transparent;
  border-right-color: #fff;
  border-left: none;
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-left-top {
  left: -21px;
  top: 10px;
  transform: none;
  border: 12px solid transparent;
  border-right-color: #fff;
  border-left: none;
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-right {
  right: -12px;
  left: auto;
  top: 50%;
  transform: translateY(-50%);
  border: 12px solid transparent;
  border-left-color: #fff;
  border-right: none;
  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-right-top {
  right: -21px;
  left: auto;
  top: 10px;
  transform: none;
  border: 12px solid transparent;
  border-left-color: #fff;
  border-right: none;
  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-left-bottom {
  left: -21px;
  bottom: 10px;
  transform: none;
  border: 12px solid transparent;
  border-right-color: #fff;
  border-left: none;
  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-right-bottom {
  right: -21px;
  left: auto;
  bottom: 10px;
  transform: none;
  border: 12px solid transparent;
  border-left-color: #fff;
  border-right: none;
  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));
}

.tour-step-arrow-bottom-left {
  bottom: -30px;
  left: 15px;
  transform: none;
  border-top-color: #fff;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-arrow-bottom-right {
  bottom: -30px;
  left: auto;
  right: 15px;
  transform: none;
  border-top-color: #fff;
  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));
}

.tour-step-card .tour-step-header {
  display: flex;
  padding: 0px 0px 0px 16px;
  flex-direction: row;
  align-items: center;
}

.tour-step-card .header-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 8px;
}

.tour-step-card .tour-step-title {
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.2;
  margin: 0;
  color: rgba(0, 0, 0, 0.87);
}

.tour-step-card .close {
  margin: -6px -6px 0 0;
  color: rgba(0, 0, 0, 0.7);
}
.tour-step-card .close:hover {
  color: rgba(0, 0, 0, 0.87);
  background: rgba(0, 0, 0, 0.04);
}

.tour-step-card .tour-step-content {
  padding: 2px 16px 12px;
  font-size: 1.3625rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
  margin: 0;
}

.tour-step-actions {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 8px 12px;
  width: 100%;
  padding: 10px 0px 0px !important;
  margin: 0 !important;
  border-top: none !important;
  min-height: 44px;
}
.tour-step-actions .tour-step-counter {
  font-size: 1.5625rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.7);
  flex-shrink: 0;
}
.tour-step-actions .prev,
.tour-step-actions .next,
.tour-step-actions .tour-done {
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}
.tour-step-actions .prev.mat-mdc-button:not(:disabled) {
  color: rgba(0, 0, 0, 0.87) !important;
}
.tour-step-actions .prev.mat-mdc-button:disabled {
  color: rgba(0, 0, 0, 0.38) !important;
  opacity: 1;
}
.tour-step-actions .prev .mat-icon {
  color: inherit;
}
.tour-step-actions .next,
.tour-step-actions .tour-done {
  color: var(--fuse-primary, #2196f3);
  font-weight: 600;
}

.tour-step-card .tour-step-actions {
  border-top: none !important;
}

body.tour-active .quick-panel,
body.tour-active .fuse-sidebar,
body.tour-active .search-panel,
body.tour-active .chat-panel {
  display: none !important;
}

body[class*=-dark] .mat-mdc-menu-panel.tour-step {
  background: #424242 !important;
  color: rgba(255, 255, 255, 0.87);
}
body[class*=-dark] .mat-mdc-menu-panel.tour-step .mat-mdc-menu-content {
  background: transparent;
}
body[class*=-dark] .tour-step-card {
  background: #424242;
  color: rgba(255, 255, 255, 0.87);
}
body[class*=-dark] .tour-step-arrow-bottom,
body[class*=-dark] .tour-step-arrow-bottom-left,
body[class*=-dark] .tour-step-arrow-bottom-right {
  border-top-color: #424242;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.35));
}
body[class*=-dark] .tour-step-arrow-top,
body[class*=-dark] .tour-step-arrow-top-left,
body[class*=-dark] .tour-step-arrow-top-right {
  border-bottom-color: #424242;
  filter: drop-shadow(0 -2px 4px rgba(0, 0, 0, 0.35));
}
body[class*=-dark] .tour-step-arrow-left,
body[class*=-dark] .tour-step-arrow-left-top,
body[class*=-dark] .tour-step-arrow-left-bottom {
  border-right-color: #424242;
  filter: drop-shadow(-2px 0 4px rgba(0, 0, 0, 0.35));
}
body[class*=-dark] .tour-step-arrow-right,
body[class*=-dark] .tour-step-arrow-right-top,
body[class*=-dark] .tour-step-arrow-right-bottom {
  border-left-color: #424242;
  filter: drop-shadow(2px 0 4px rgba(0, 0, 0, 0.35));
}
body[class*=-dark] .tour-step-card .tour-step-title {
  color: rgba(255, 255, 255, 0.87);
}
body[class*=-dark] .tour-step-card .close {
  color: rgba(255, 255, 255, 0.7);
}
body[class*=-dark] .tour-step-card .close:hover {
  color: rgba(255, 255, 255, 0.87);
  background: rgba(255, 255, 255, 0.08);
}
body[class*=-dark] .tour-step-card .tour-step-content {
  color: rgba(255, 255, 255, 0.7);
}
body[class*=-dark] .tour-step-actions .tour-step-counter {
  color: rgba(255, 255, 255, 0.7);
}
body[class*=-dark] .tour-step-actions .prev.mat-mdc-button:not(:disabled) {
  color: rgba(255, 255, 255, 0.87) !important;
}
body[class*=-dark] .tour-step-actions .prev.mat-mdc-button:disabled {
  color: rgba(255, 255, 255, 0.38) !important;
  opacity: 1;
}
body[class*=-dark] .tour-step-actions .next,
body[class*=-dark] .tour-step-actions .tour-done {
  color: var(--fuse-primary, #64b5f6);
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ui-tour/ui-tour.component.scss"],"names":[],"mappings":"AAEA;EACE,wBAAA;AADF;;AAIA;EACE,eAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,2BAAA;AADF;;AAIA;EACE,4BAAA;EACA,6BAAA;EACA,8BAAA;EACA,4BAAA;EACA,+BAAA;AADF;;AAGA;EACE,wBAAA;AAAF;;AAaA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAjBmB;AAOrB;;AAaA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,gDAAA;EACA,UAAA;AAVF;;AAaA;EACE,aAAA;EACA,SAAA;EACA,2BAAA;EACA,sBAjCmB;EAkCnB,kDAAA;AAVF;;AAaA;EACE,UAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAzCmB;EA0CnB,mDAAA;AAVF;;AAaA;EACE,UAAA;EACA,UAAA;EACA,yBAhDmB;EAiDnB,mDAAA;AAVF;;AAaA;EACE,UAAA;EACA,UAAA;EACA,WAAA;EACA,yBAxDmB;EAyDnB,mDAAA;AAVF;;AAaA;EACE,WAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,wBAjEmB;EAkEnB,iBAAA;EACA,mDAAA;AAVF;;AAaA;EACE,WAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,wBA3EmB;EA4EnB,iBAAA;EACA,mDAAA;AAVF;;AAaA;EACE,YAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,uBAtFmB;EAuFnB,kBAAA;EACA,kDAAA;AAVF;;AAaA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAjGmB;EAkGnB,kBAAA;EACA,kDAAA;AAVF;;AAaA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,wBA3GmB;EA4GnB,iBAAA;EACA,mDAAA;AAVF;;AAaA;EACE,YAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAtHmB;EAuHnB,kBAAA;EACA,kDAAA;AAVF;;AAaA;EACE,aAAA;EACA,UAAA;EACA,eAAA;EACA,sBA/HmB;EAgInB,kDAAA;AAVF;;AAaA;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,sBAxImB;EAyInB,kDAAA;AAVF;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAVF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,QAAA;AATF;;AAWA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,0BA5JwB;AAoJ1B;;AAUA;EACE,qBAAA;EACA,yBA/J0B;AAwJ5B;AAQE;EACE,0BAlKsB;EAmKtB,+BAAA;AANJ;;AAUA;EACE,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBA1K0B;EA2K1B,SAAA;AAPF;;AAUA;EACE,wBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EACA,WAAA;EACA,gCAAA;EACA,oBAAA;EACA,2BAAA;EACA,gBAAA;AAPF;AASE;EACE,oBAAA;EACA,gBAAA;EACA,yBA7LwB;EA8LxB,cAAA;AAPJ;AAUE;;;EAGE,gBAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAYE;EACE,qCAAA;AAVJ;AAYE;EACE,qCAAA;EACA,UAAA;AAVJ;AAYE;EACE,cAAA;AAVJ;AAaE;;EAEE,mCAAA;EACA,gBAAA;AAXJ;;AAeA;EACE,2BAAA;AAZF;;AAeA;;;;EAIE,wBAAA;AAZF;;AAmBE;EACE,8BAAA;EACA,gCA5OqB;AA4NzB;AAmBE;EACE,uBAAA;AAjBJ;AAoBE;EACE,mBAvPgB;EAwPhB,gCArPqB;AAmOzB;AAqBE;;;EAGE,yBA9PgB;EA+PhB,kDAAA;AAnBJ;AAsBE;;;EAGE,4BArQgB;EAsQhB,mDAAA;AApBJ;AAuBE;;;EAGE,2BA5QgB;EA6QhB,mDAAA;AArBJ;AAwBE;;;EAGE,0BAnRgB;EAoRhB,kDAAA;AAtBJ;AAyBE;EACE,gCArRqB;AA8PzB;AA0BE;EACE,+BAxRuB;AAgQ3B;AAyBI;EACE,gCA3RmB;EA4RnB,qCAAA;AAvBN;AA2BE;EACE,+BAhSuB;AAuQ3B;AA6BI;EACE,+BArSqB;AA0Q3B;AA8BI;EACE,2CAAA;AA5BN;AA8BI;EACE,2CAAA;EACA,UAAA;AA5BN;AA+BI;;EAEE,mCAAA;EACA,gBAAA;AA7BN","sourcesContent":["// Ngx UI Tour – step card, arrows, overlay and backdrop (encapsulation: none so overlay/backdrop can be styled)\n\n.cdk-overlay-container {\n  z-index: 1003 !important;\n}\n\n.mat-mdc-menu-panel.tour-step {\n  margin-top: 4px;\n  overflow: visible !important;\n  padding: 0 !important;\n  min-width: 250px !important;\n  max-width: min(1360px, 95vw) !important;\n  width: auto !important;\n  box-shadow: none !important;\n}\n\n.mat-mdc-menu-panel.tour-step .mat-mdc-menu-content {\n  overflow: visible !important;\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n.mat-mdc-menu-content.tour-step-card {\n  padding: 15px !important;\n}\n\n// Fuse applies dark themes as body classes ending in `-dark` (e.g. theme-grey-dark).\n$tour-surface-light: #fff;\n$tour-surface-dark: #424242;\n$tour-text-primary-light: rgba(0, 0, 0, 0.87);\n$tour-text-secondary-light: rgba(0, 0, 0, 0.7);\n$tour-text-primary-dark: rgba(255, 255, 255, 0.87);\n$tour-text-secondary-dark: rgba(255, 255, 255, 0.7);\n$tour-text-disabled-dark: rgba(255, 255, 255, 0.38);\n$tour-text-disabled-light: rgba(0, 0, 0, 0.38);\n\n.tour-step-card {\n  position: relative;\n  overflow: visible;\n  width: auto;\n  min-width: 250px;\n  max-width: min(1360px, 95vw);\n  border-radius: 12px;\n  box-shadow: none;\n  background: $tour-surface-light;\n}\n\n.tour-step-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border: 10px solid transparent;\n  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.08));\n  z-index: 1;\n}\n\n.tour-step-arrow-bottom {\n  bottom: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-color: $tour-surface-light;\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-arrow-top {\n  top: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-bottom-color: $tour-surface-light;\n  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-arrow-top-left {\n  top: -30px;\n  left: 15px;\n  border-bottom-color: $tour-surface-light;\n  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-arrow-top-right {\n  top: -30px;\n  left: auto;\n  right: 15px;\n  border-bottom-color: $tour-surface-light;\n  filter: drop-shadow(0 -2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-arrow-left {\n  left: -21px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 12px solid transparent;\n  border-right-color: $tour-surface-light;\n  border-left: none;\n  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-left-top {\n  left: -21px;\n  top: 10px;\n  transform: none;\n  border: 12px solid transparent;\n  border-right-color: $tour-surface-light;\n  border-left: none;\n  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-right {\n  right: -12px;\n  left: auto;\n  top: 50%;\n  transform: translateY(-50%);\n  border: 12px solid transparent;\n  border-left-color: $tour-surface-light;\n  border-right: none;\n  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-right-top {\n  right: -21px;\n  left: auto;\n  top: 10px;\n  transform: none;\n  border: 12px solid transparent;\n  border-left-color: $tour-surface-light;\n  border-right: none;\n  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-left-bottom {\n  left: -21px;\n  bottom: 10px;\n  transform: none;\n  border: 12px solid transparent;\n  border-right-color: $tour-surface-light;\n  border-left: none;\n  filter: drop-shadow(-2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-right-bottom {\n  right: -21px;\n  left: auto;\n  bottom: 10px;\n  transform: none;\n  border: 12px solid transparent;\n  border-left-color: $tour-surface-light;\n  border-right: none;\n  filter: drop-shadow(2px 0 2px rgba(0, 0, 0, 0.12));\n}\n\n.tour-step-arrow-bottom-left {\n  bottom: -30px;\n  left: 15px;\n  transform: none;\n  border-top-color: $tour-surface-light;\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-arrow-bottom-right {\n  bottom: -30px;\n  left: auto;\n  right: 15px;\n  transform: none;\n  border-top-color: $tour-surface-light;\n  filter: drop-shadow(0 2px 2px rgba(0, 0, 0, 0.08));\n}\n\n.tour-step-card .tour-step-header {\n  display: flex;\n  padding: 0px 0px 0px 16px;\n  flex-direction: row;\n  align-items: center;\n}\n.tour-step-card .header-group {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 8px;\n}\n.tour-step-card .tour-step-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  margin: 0;\n  color: $tour-text-primary-light;\n}\n.tour-step-card .close {\n  margin: -6px -6px 0 0;\n  color: $tour-text-secondary-light;\n  &:hover {\n    color: $tour-text-primary-light;\n    background: rgba(0, 0, 0, 0.04);\n  }\n}\n\n.tour-step-card .tour-step-content {\n  padding: 2px 16px 12px;\n  font-size: 1.3625rem;\n  line-height: 1.5;\n  color: $tour-text-secondary-light;\n  margin: 0;\n}\n\n.tour-step-actions {\n  display: flex !important;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  gap: 8px 12px;\n  width: 100%;\n  padding: 10px 0px 0px !important;\n  margin: 0 !important;\n  border-top: none !important;\n  min-height: 44px;\n\n  .tour-step-counter {\n    font-size: 1.5625rem;\n    font-weight: 600;\n    color: $tour-text-secondary-light;\n    flex-shrink: 0;\n  }\n\n  .prev,\n  .next,\n  .tour-done {\n    font-weight: 500;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n\n  // Prev uses default MDC text; on dark-themed app + white card it became invisible — force readable colors.\n  .prev.mat-mdc-button:not(:disabled) {\n    color: $tour-text-primary-light !important;\n  }\n  .prev.mat-mdc-button:disabled {\n    color: $tour-text-disabled-light !important;\n    opacity: 1;\n  }\n  .prev .mat-icon {\n    color: inherit;\n  }\n\n  .next,\n  .tour-done {\n    color: var(--fuse-primary, #2196f3);\n    font-weight: 600;\n  }\n}\n\n.tour-step-card .tour-step-actions {\n  border-top: none !important;\n}\n\nbody.tour-active .quick-panel,\nbody.tour-active .fuse-sidebar,\nbody.tour-active .search-panel,\nbody.tour-active .chat-panel {\n  display: none !important;\n}\n\n// ---------------------------------------------------------------------------\n// Dark theme (body class from FuseConfig.colorTheme, e.g. theme-grey-dark)\n// ---------------------------------------------------------------------------\nbody[class*='-dark'] {\n  .mat-mdc-menu-panel.tour-step {\n    background: $tour-surface-dark !important;\n    color: $tour-text-primary-dark;\n  }\n\n  .mat-mdc-menu-panel.tour-step .mat-mdc-menu-content {\n    background: transparent;\n  }\n\n  .tour-step-card {\n    background: $tour-surface-dark;\n    color: $tour-text-primary-dark;\n  }\n\n  .tour-step-arrow-bottom,\n  .tour-step-arrow-bottom-left,\n  .tour-step-arrow-bottom-right {\n    border-top-color: $tour-surface-dark;\n    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.35));\n  }\n\n  .tour-step-arrow-top,\n  .tour-step-arrow-top-left,\n  .tour-step-arrow-top-right {\n    border-bottom-color: $tour-surface-dark;\n    filter: drop-shadow(0 -2px 4px rgba(0, 0, 0, 0.35));\n  }\n\n  .tour-step-arrow-left,\n  .tour-step-arrow-left-top,\n  .tour-step-arrow-left-bottom {\n    border-right-color: $tour-surface-dark;\n    filter: drop-shadow(-2px 0 4px rgba(0, 0, 0, 0.35));\n  }\n\n  .tour-step-arrow-right,\n  .tour-step-arrow-right-top,\n  .tour-step-arrow-right-bottom {\n    border-left-color: $tour-surface-dark;\n    filter: drop-shadow(2px 0 4px rgba(0, 0, 0, 0.35));\n  }\n\n  .tour-step-card .tour-step-title {\n    color: $tour-text-primary-dark;\n  }\n\n  .tour-step-card .close {\n    color: $tour-text-secondary-dark;\n    &:hover {\n      color: $tour-text-primary-dark;\n      background: rgba(255, 255, 255, 0.08);\n    }\n  }\n\n  .tour-step-card .tour-step-content {\n    color: $tour-text-secondary-dark;\n  }\n\n  .tour-step-actions {\n    .tour-step-counter {\n      color: $tour-text-secondary-dark;\n    }\n\n    .prev.mat-mdc-button:not(:disabled) {\n      color: $tour-text-primary-dark !important;\n    }\n    .prev.mat-mdc-button:disabled {\n      color: $tour-text-disabled-dark !important;\n      opacity: 1;\n    }\n\n    .next,\n    .tour-done {\n      color: var(--fuse-primary, #64b5f6);\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
